import React from 'react';

import {labels} from '../../../../../../util/utils';

import Button from '../../../../../CoreWrappers/Button';
import StyledTriggerWrapper from './StyledTriggerWrapper';

const ManageTags = ({setShow}) => {
	const renderTrigger = () => {
		const props = {
			variant: 'text-alt',
			onClick: () => setShow(true),
			children: labels.manageTagLinkButton
		};

		return <Button {...props} />;
	};

	return <StyledTriggerWrapper>{renderTrigger()}</StyledTriggerWrapper>;
};

export default ManageTags;
